import * as React from 'react';

//MUI
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuItem from '@mui/material/MenuItem';
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import HoverMenu from 'material-ui-popup-state/HoverMenu'
import { usePopupState, bindHover, bindMenu, } from 'material-ui-popup-state/hooks'

//Images
import logo from '../assets/images/logo.webp'



export default function Navbar() {

    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'navMenu',
    })

    const menuItem = {
        paddingBottom: 0,
        paddingTop: 0,
        backgroundColor: '#231f20 !important',
    }

    const sxLink = {
        color:'#ffffff',
        paddingBottom: "10px",
        paddingTop: "10px",
        width: '100%',
        "&:hover": {
            color: '#e31837'
        },
    }

    const [open, setState] = React.useState(false);
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState(open);
    };


    return (
        <Box>
            <CssBaseline />
            <AppBar position="static" sx={{ backgroundColor: "#231f20", borderBottom: '5px solid #000000'}}>
                <Toolbar>
                    <Box sx={{ flexGrow: 1 }}>
                        <a href='/'>
                            <img src={logo} alt="" height="28px" />
                        </a>
                    </Box>

                    {/* On Large Screen */}
                    <Box sx={{
                        display: {
                            xs: 'none',
                            lg: 'flex',
                        },
                        alignItems: 'center',
                    }}>
                        <Link underline="none" mr={4} href='/sectiona' className={'un nav'}>
                            General Disclosures
                        </Link>
                        <Link underline="none" mr={4} href='/sectionb' className={'un nav'}>
                            Management &amp; Process Disclosures
                        </Link>
                        <Box display="flex" alignItems="center" {...bindHover(popupState)}>
                            <Link underline="none" className={'un nav'} sx={{cursor:'pointer'}}>
                                Principle Wise Disclosures
                            </Link>
                            <ArrowDropDownIcon sx={{color: '#ffffff'}}/>
                            <span style={{ visibility: 'hidden', paddingBottom: '20px' }}>.</span>
                        </Box>
                        <HoverMenu
                            {...bindMenu(popupState)}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            sx={{
                                '& .MuiList-root': {
                                  paddingTop: 0,
                                  paddingBottom: 0,
                                },
                              }}
                        >
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc1' underline="none">Principle 1: Integrity and Ethics</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc2' underline="none">Principle 2: Sustainable Product</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc3' underline="none">Principle 3: Employee Wellbeing</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc4' underline="none">Principle 4: Stakeholder Interest</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc5' underline="none">Principle 5: Human Rights</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc6' underline="none">Principle 6: Environment</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc7' underline="none">Principle 7: Regulatory Policy</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc8' underline="none">Principle 8: Inclusive Growth</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/sectionc9' underline="none">Principle 9: Consumer and IT</Link>
                            </MenuItem>
                            <Divider style={{ margin: 0, backgroundColor: '#4d4d4f' }} />
                            <MenuItem sx={menuItem}>
                                <Link sx={sxLink} href='/assurance-report' underline="none">Assurance Report</Link>
                            </MenuItem>
                        </HoverMenu>

                    </Box>

                    {/* On Small Screen */}
                    <Box sx={{
                        display: {
                            xs: 'flex',
                            lg: 'none'
                        }
                    }}>
                        <IconButton
                            edge="start"
                            color="#ffffff"
                            aria-label="open drawer"
                            onClick={toggleDrawer(true)}
                            sx={{
                                mr: 2,
                            }}
                        >
                            <MenuIcon sx={{ color: "#ffffff" }} />
                        </IconButton>

                        <Drawer
                            anchor="right"
                            open={open}
                            onClose={toggleDrawer(false)}
                            onOpen={toggleDrawer(true)}
                            PaperProps={{
                                sx: {
                                    backgroundColor: "#231f20"
                                }
                            }}
                        >
                            <Box>
                                <IconButton sx={{ my: 2 }} onClick={toggleDrawer(false)}>
                                    <CloseIcon sx={{ color: "#ffffff" }} />
                                </IconButton>

                                <Divider sx={{ mb: 2, bgcolor: "white" }} />
                                <Box sx={{ color: "white" }}>
                                    <ListItemButton href='/sectiona'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectiona' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="General Disclosures" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionb'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionb' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Management and Process Disclosures" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc1'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc1' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 1" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc2'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc2' ? '#e31837' : '#ffffff',

                                        }}
                                    >
                                        <ListItemText primary="Principle 2" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc3'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc3' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 3" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc4'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc4' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 4" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc5'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc5' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 5" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc6'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc6' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 6" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc7'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc7' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 7" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc8'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc8' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 8" />
                                    </ListItemButton>
                                    <ListItemButton href='/sectionc9'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/sectionc9' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Principle 9" />
                                    </ListItemButton>
                                    <ListItemButton href='/assurance-report'
                                        sx={{
                                            '&:hover': {
                                                color: '#ffffff',
                                                fontWeight: 'bold'
                                            },
                                            color: window.location.pathname === '/assurance-report' ? '#e31837' : '#ffffff',
                                        }}
                                    >
                                        <ListItemText primary="Assurance Report" />
                                    </ListItemButton>
                                </Box>
                            </Box>
                        </Drawer>
                    </Box>
                </Toolbar>
            </AppBar>
        </Box >
    );
}